export enum PaymentMethod {
    MEMBER = 'MEMBER',
    COUPON = 'COUPON',
    CARD = 'CARD',
    LATER = 'LATER',
    FREE = 'FREE',
}
